import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { ImageFeatureWithLink } from './image-feature-with-link-model';
import { FooterLinkModel } from './footer-link-model';
import { IFooterLinkProps } from '../components/footer/footer-link/footer-link';
import { SocialMediaPanelModel } from './social-media-panel-model';
import { ISocialMediaPanelProps } from '../components/social-media-panel/social-media-panel';
import { IFooterExtrasProps } from '../components/footer/footer-extras/footer-extras';
import { IImageFeatureWithLinkProps } from '../components/image-feature-with-link/image-feature-with-link';

export class FooterExtrasModel extends ContentItem {
  get logo(): string {
    return get(this._config, 'elements.logo.value[0].url', '');
  }

  get linkImagesTitle(): string {
    return get(this._config, 'elements.link_images_title.value', '');
  }

  get linkImages(): IImageFeatureWithLinkProps[] {
    const linkImages = get(this._config, 'elements.link_images.value', []);
    const modeledLinkImages = linkImages
      ? linkImages.map((linkImage: IImageFeatureWithLink) =>
          ImageFeatureWithLink.create(linkImage)
        )
      : [];
    return modeledLinkImages;
  }

  get socialMedia(): ISocialMediaPanelProps {
    const socialMedia = get(this._config, 'elements.social_media.value[0]', '');

    const modeledSocialMedia = SocialMediaPanelModel.create(socialMedia);
    return modeledSocialMedia;
  }

  get bottomLink(): IFooterLinkProps[] {
    const bottomLink = get(this._config, 'elements.bottom_link.value', []);

    const modeledBottomLink = bottomLink.map((link: IFooterLink) =>
      FooterLinkModel.create(link)
    );
    return modeledBottomLink;
  }

  public static create(data: IFooterExtras): IFooterExtrasProps {
    const {
      linkImagesTitle,
      linkImages,
      socialMedia,
      bottomLink,
      logo
    } = new FooterExtrasModel(data);
    return {
      linkImagesTitle,
      linkImages,
      socialMedia,
      bottomLink,
      logo
    };
  }
}
